import { Component, OnInit } from "@angular/core";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { TranslateService } from "@ngx-translate/core";
import { ShareHoldersService } from "../../services/share-holders/share-holders.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";

@Component({
  selector: "app-share-holders",
  templateUrl: "./share-holders.component.html",
  styleUrls: ["./share-holders.component.css"],
})
export class ShareHoldersComponent implements OnInit {
  shareHolders: any[] = [];
  loading = false;

  isAdding = false;
  newName = "";
  newErpCode = "";

  editCache: { [key: string]: any } = {};

  constructor(
    private shareHoldersService: ShareHoldersService,
    private errorHandlerService: ErrorHandlerService,
    private slimLoadingBarService: SlimLoadingBarService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.load();
  }

  t(key: string) {
    return this.translate.instant(key);
  }

  trackById(index: number, item: any) {
    return item && item.id != null ? item.id : index;
  }

  load() {
    this.loading = true;
    this.slimLoadingBarService.start();

    this.shareHoldersService.getShareHolders().subscribe(
      (res: any) => {
        const list = res && res.data ? res.data : res;
        this.shareHolders = Array.isArray(list) ? list : [];
        this.isAdding = false;
        this.newName = "";
        this.newErpCode = "";
      },
      (err) => {
        this.loading = false;
        this.slimLoadingBarService.complete();
        this.errorHandlerService.handleErorr(err);
      },
      () => {
        this.loading = false;
        this.slimLoadingBarService.complete();
      }
    );
  }

  openAdd() {
    this.isAdding = true;
    this.newName = "";
    this.newErpCode = "";
  }

  cancelAdd() {
    this.isAdding = false;
    this.newName = "";
    this.newErpCode = "";
  }

  saveNew() {
    const name = (this.newName || "").trim();
    const erp_code = (this.newErpCode || "").trim();
    if (!name) {
      return;
    }

    this.loading = true;
    this.slimLoadingBarService.start();
    this.shareHoldersService.createShareHolder({ name, erp_code }).subscribe(
      () => {
        swal(
          this.t("settings.general.share_holders.messages.created"),
          "",
          "success"
        );
        this.load();
      },
      (err) => {
        this.loading = false;
        this.slimLoadingBarService.complete();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  startEdit(holder: any) {
    if (!holder) {
      return;
    }
    this.editCache[String(holder.id)] = { ...holder };
    holder.edit_mode = true;
  }

  cancelEdit(holder: any) {
    const key = String(holder.id);
    const backup = this.editCache[key];
    if (backup) {
      Object.keys(backup).forEach((k) => (holder[k] = backup[k]));
    }
    holder.edit_mode = false;
    delete this.editCache[key];
  }

  saveEdit(holder: any) {
    if (!holder || !holder.id) {
      return;
    }

    const name = (holder.name || "").trim();
    const erp_code = (holder.erp_code || "").trim();
    if (!name) {
      return;
    }

    this.loading = true;
    this.slimLoadingBarService.start();
    this.shareHoldersService
      .updateShareHolder(holder.id, { name, erp_code })
      .subscribe(
        () => {
          holder.edit_mode = false;
          delete this.editCache[String(holder.id)];
          swal(
            this.t("settings.general.share_holders.messages.updated"),
            "",
            "success"
          );
          this.load();
        },
        (err) => {
          this.loading = false;
          this.slimLoadingBarService.complete();
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  delete(holder: any) {
    if (!holder || !holder.id) {
      return;
    }

    swal({
      title: this.t("settings.general.share_holders.confirm_delete.title"),
      text: this.t("settings.general.share_holders.confirm_delete.text"),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.t(
        "settings.general.share_holders.confirm_delete.confirm"
      ),
      cancelButtonText: this.t(
        "settings.general.share_holders.confirm_delete.cancel"
      ),
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.slimLoadingBarService.start();
        this.shareHoldersService.deleteShareHolder(holder.id).subscribe(
          () => {
            swal(
              this.t("settings.general.share_holders.messages.deleted"),
              "",
              "success"
            );
            this.load();
          },
          (err) => {
            this.loading = false;
            this.slimLoadingBarService.complete();
            this.errorHandlerService.handleErorr(err);
          }
        );
      }
    });
  }

  export() {
    const html = `
      <table border="1">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>ERP Code</th>
            <th>Created At</th>
            <th>Updated At</th>
          </tr>
        </thead>
        <tbody>
          ${this.shareHolders
            .map(
              (s) => `
            <tr>
              <td>${s && s.id != null ? s.id : ""}</td>
              <td>${s && s.name != null ? s.name : ""}</td>
              <td>${s && s.erp_code != null ? s.erp_code : ""}</td>
              <td>${s && s.created_at != null ? s.created_at : ""}</td>
              <td>${s && s.updated_at != null ? s.updated_at : ""}</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>
    `;

    const blob = new Blob([html], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Share_Holders.xls";
    a.click();
    window.URL.revokeObjectURL(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/share-holders/share-holders.component.ts